module.exports = __webpack_public_path__ + "assets/cfa218cb0a63456695e87afb75c038b6.mp3";